import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { Slide } from '../../types';
import { useLang } from '../../contexts/langContext';

interface BasicEditDialogProps {
  open: boolean;
  onClose: () => void;
  slide: Slide;
  onSave: (contentDescription: string) => void;
}

function BasicEditDialog({
  open,
  onClose,
  onSave,
  slide,
}: BasicEditDialogProps) {
  console.log('slide:', slide);
  const { lang } = useLang();
  const [contentDescription, setContentDescription] = useState(slide.contentDescription || '');

  const handleSave = () => {
    onSave(contentDescription);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{lang === 'en' ? 'Edit Slide Description' : '编辑幻灯片描述'}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={3}
          label={lang === 'en' ? 'Description of current slide' : '此页描述'}
          helperText={lang === 'en' ? 'Describe the purpose of this slide, not the actual content' : '描述此幻灯片的目的，而非实际文字内容'}
          placeholder={lang === 'en' ? 'Description of this slide, e.g. This is title slide, or this slide introduce our team' : '描述此幻灯片，例如：这是标题页，或者此页介绍我们团队'}
          value={contentDescription}
          onChange={(e) => {
            setContentDescription(e.target.value);
          }}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{lang === 'en' ? 'Cancel' : '取消'}</Button>
        <Button onClick={handleSave} variant="contained">{lang === 'en' ? 'Save' : '保存'}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default BasicEditDialog; 